'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactPlayer = require('react-player');

var _reactPlayer2 = _interopRequireDefault(_reactPlayer);

var _videoGallerySdk = require('@wix/video-gallery-sdk');

var VideoGallerySDK = _interopRequireWildcard(_videoGallerySdk);

var _player = require('@vimeo/player');

var _player2 = _interopRequireDefault(_player);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _fullscreenItemPreload = require('./fullscreenItemPreload.js');

var _fullscreenItemPreload2 = _interopRequireDefault(_fullscreenItemPreload);

var _utils = require('../utils');

var _play = require('-!svg-react-loader!../assets/images/video/play.svg');

var _play2 = _interopRequireDefault(_play);

var _pause = require('-!svg-react-loader!../assets/images/video/pause.svg');

var _pause2 = _interopRequireDefault(_pause);

var _faCircleONotch = require('-!svg-react-loader!../assets/images/video/fa-circle-o-notch.svg');

var _faCircleONotch2 = _interopRequireDefault(_faCircleONotch);

var _windowWrapper = require('@wix/photography-client-lib/dist/src/sdk/windowWrapper');

var _windowWrapper2 = _interopRequireDefault(_windowWrapper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenVideo = function (_React$Component) {
  (0, _inherits3.default)(FullscreenVideo, _React$Component);

  function FullscreenVideo(props) {
    (0, _classCallCheck3.default)(this, FullscreenVideo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenVideo.__proto__ || (0, _getPrototypeOf2.default)(FullscreenVideo)).call(this, props));

    if (props.item.videoUrl && props.item.videoUrl.includes('wix:video://')) {
      _this.shouldUseWixUrl = true;
    } else {
      _this.shouldUseWixUrl = false;
    }
    //Vimeo player must be loaded by us, problem with requireJS
    if (!(_windowWrapper2.default && _windowWrapper2.default.Vimeo) && props.item.videoUrl && props.item.videoUrl.includes('vimeo.com')) {
      _windowWrapper2.default.Vimeo = { Player: _player2.default };
    }
    _this.handleArrowKeys = _this.handleArrowKeys.bind(_this);

    _this.state = {
      buffering: false,
      duration: 0,
      volume: 0.8,
      playing: true,
      played: 0,
      loaded: 0,
      mute: false
    };
    return _this;
  }

  (0, _createClass3.default)(FullscreenVideo, [{
    key: 'initWixCodeVideoUrl',
    value: function initWixCodeVideoUrl() {
      var _this2 = this;

      var id = this.props.item.dto.mediaUrl;
      var requiredHeight = this.props.item.height;
      VideoGallerySDK.getVideoURLs(id).then(function (urls) {
        var mp4Qualities = urls.filter(function (video) {
          return video.type === 'MP4';
        });
        var currentQuality = void 0;
        for (var quality, q = 0; quality = mp4Qualities[q]; q++) {
          currentQuality = Number(quality.quality.slice(0, -1));
          if (currentQuality >= requiredHeight || !mp4Qualities[q + 1]) {
            _this2.setState({
              wixLocalUrl: _windowWrapper2.default.location.protocol + mp4Qualities[q].url
            });
            break;
          }
        }
      });
    }
  }, {
    key: 'fixIFrameTabIndexIfNeeded',
    value: function fixIFrameTabIndexIfNeeded() {
      if (this.props.item.metadata.isExternal) {
        var videoGalleryItem = _windowWrapper2.default.document && _windowWrapper2.default.document.getElementById('fullscreen-video-' + this.props.item.id);
        var videoIFrames = videoGalleryItem && videoGalleryItem.getElementsByTagName('iframe');
        var videoIFrame = videoIFrames && videoIFrames[0];
        if (videoIFrame) {
          if (this.props.isDisplayed) {
            //isDisplayed={this.props.current.idx === idx}
            videoIFrame.setAttribute('tabIndex', '0');
          } else {
            videoIFrame.setAttribute('tabIndex', '-1');
          }
        }
      }
    }
  }, {
    key: 'clickOffset',
    value: function clickOffset(e) {
      var element = e.currentTarget;
      var clickOffsetInElement = e.pageX - (0, _jquery2.default)(element).offset().left;
      var elementWidth = element.getBoundingClientRect().width;
      return clickOffsetInElement / elementWidth;
    }
  }, {
    key: 'seekTo',
    value: function seekTo(e) {
      var played = this.clickOffset(e);
      this.video.seekTo(played);
      this.setState({ played: played });
    }
  }, {
    key: 'changeVideoLocation',
    value: function changeVideoLocation(diff) {
      var played = this.state.played + diff;
      this.video.seekTo(played);
      this.setState({ played: played });
    }
  }, {
    key: 'setVolume',
    value: function setVolume(e) {
      this.setState({ volume: this.clickOffset(e), mute: false });
    }
  }, {
    key: 'changeVolume',
    value: function changeVolume(diff) {
      this.setState({ volume: this.state.volume + diff, mute: false });
    }
  }, {
    key: 'togglePlay',
    value: function togglePlay() {
      this.state.playing ? this.pause() : this.play();
    }
  }, {
    key: 'isExternalMobileVideo',
    value: function isExternalMobileVideo() {
      return _utils.utils.isMobile() && !this.props.isDummy && this.props.item.metadata.isExternal;
    }
  }, {
    key: 'secondsToTimeString',
    value: function secondsToTimeString(seconds) {
      if (!(seconds >= 0)) {
        //could also be NaN
        seconds = 0;
      }
      var hourFixer = seconds >= 3600 ? 3 : 0;
      return new Date(seconds * 1000).toISOString().substr(14 + hourFixer, 5 + hourFixer);
    }
  }, {
    key: 'onProgress',
    value: function onProgress(_ref) {
      var loaded = _ref.loaded,
          played = _ref.played;

      this.setState({ loaded: loaded, played: played });
    }
  }, {
    key: 'play',
    value: function play() {
      this.setState({ playing: true, playedOnce: true });
    }
  }, {
    key: 'pause',
    value: function pause() {
      this.setState({ playing: false });
    }
  }, {
    key: 'autoPlay',
    value: function autoPlay() {
      if (this.props.isDisplayed && !_utils.utils.isMobile()) {
        this.play();
      } else if (!this.props.isDummy) {
        this.pause();
      }
    }
  }, {
    key: 'handleArrowKeys',
    value: function handleArrowKeys(e) {
      if (!_utils.utils.isAccessibilityEnabled() || !this.props.isDisplayed) {
        //the keypress events are only effective when the video is displayed
        return true;
      }

      var activeControl = null;
      var activeControlClassName = document.activeElement.className || '';
      if (activeControlClassName.indexOf('fullscreen-video-controls-progress') >= 0) {
        activeControl = 'progressBar';
      } else if (activeControlClassName.indexOf('fullscreen-video-controls-volume-bar') >= 0) {
        activeControl = 'volumeBar';
      }

      switch (e.keyCode || e.charCode) {
        case 38:
          //up
          if (activeControl === 'volumeBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVolume(0.1);
          }
          return false;
        case 40:
          //down
          if (activeControl === 'volumeBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVolume(-0.1);
          }
          return false;
        case 37:
          //left
          if (activeControl === 'progressBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVideoLocation(-0.1);
          }
          return false;
        case 39:
          //right
          if (activeControl === 'progressBar') {
            e.preventDefault();
            e.stopPropagation();
            this.changeVideoLocation(0.1);
          }
          return false;
        default:
          break;
      }

      return true;
    }
  }, {
    key: 'stopPropagation',
    value: function stopPropagation(event) {
      event.stopPropagation();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.video.stopBuffering) {
        this.video.stopBuffering();
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.shouldUseWixUrl) {
        this.initWixCodeVideoUrl();
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.autoPlay();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.isDisplayed !== this.props.isDisplayed) {
        console.log('Video Did Update');
        this.autoPlay();
      }
      if (prevProps.currentIdx !== this.props.currentIdx) {
        this.fixIFrameTabIndexIfNeeded();
      }
    }
  }, {
    key: 'onWrapperClick',
    value: function onWrapperClick() {
      if (_utils.utils.isMobile() && !this.props.isDummy && !this.state.playedOnce) {
        this.setState({ playedOnce: true });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          playing = _state.playing,
          volume = _state.volume,
          played = _state.played,
          buffering = _state.buffering,
          mute = _state.mute,
          duration = _state.duration;
      var _props = this.props,
          item = _props.item,
          isDummy = _props.isDummy,
          isDisplayed = _props.isDisplayed,
          window = _props.window;


      var innerStyle = {
        width: item.width + 'px',
        height: item.height + 'px'
      };

      var controlsSize = '20';

      var videoControls = _react2.default.createElement(
        'div',
        {
          className: 'fullscreen-video-controls ' + (_utils.utils.isMobile() ? 'pro-fullscreen-mobile' : ''),
          style: innerStyle
        },
        _react2.default.createElement(
          'div',
          {
            onClick: this.togglePlay.bind(this),
            className: 'fullscreen-video-controls-wrapper'
          },
          _react2.default.createElement(
            'div',
            {
              className: 'fullscreen-video-controls-bar',
              onClick: this.stopPropagation
            },
            _react2.default.createElement(
              'button',
              {
                className: 'cursor-pointer fullscreen-video-controls-play',
                onClick: this.togglePlay.bind(this),
                tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoPlay') : -1,
                'aria-label': 'Play, toggle'
              },
              buffering ? (0, _faCircleONotch2.default)({
                className: 'pro-fullscreen-loader',
                width: controlsSize,
                height: controlsSize,
                viewBox: '0 0 14 14'
              }) : playing ? (0, _pause2.default)({
                width: controlsSize,
                height: controlsSize,
                viewBox: '0 0 11 10'
              }) : (0, _play2.default)({
                width: controlsSize,
                height: controlsSize,
                viewBox: '0 0 12 15'
              })
            ),
            _react2.default.createElement(
              'div',
              {
                className: 'cursor-pointer fullscreen-video-controls-progress',
                onClick: this.seekTo.bind(this),
                tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoBar') : -1,
                'aria-label': 'Video Progress Bar, (' + (Math.round(played * 10) * 10 + '%') + ')',
                'aria-live': 'polite',
                onKeyDown: this.handleArrowKeys,
                role: 'progressbar'
              },
              _react2.default.createElement('div', {
                className: 'fullscreen-video-controls-progress pro-fullscreen-fill',
                style: { width: played * 100 + '%' }
              })
            ),
            _react2.default.createElement(
              'span',
              { className: 'fullscreen-video-controls-time' },
              this.secondsToTimeString(duration * played)
            ),
            _react2.default.createElement(
              'span',
              { className: 'fullscreen-video-controls-slash' },
              '/'
            ),
            _react2.default.createElement(
              'span',
              { className: 'fullscreen-video-controls-time' },
              this.secondsToTimeString(duration)
            ),
            _react2.default.createElement('button', {
              className: 'cursor-pointer fullscreen-video-controls-volume-icon progallery-svg-font-icons-volume',
              onClick: function onClick() {
                _this3.setState({ mute: !mute });
              },
              tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoMute') : -1,
              'aria-label': '' + (this.state.mute ? 'Unmute' : 'Mute')
            }),
            _react2.default.createElement(
              'div',
              {
                className: 'cursor-pointer fullscreen-video-controls-volume-bar',
                onClick: this.setVolume.bind(this),
                tabIndex: isDisplayed ? _utils.utils.getTabIndex('fullscreenVideoVolume') : -1,
                'aria-label': 'Volume Controller',
                'aria-live': 'polite',
                onKeyDown: this.handleArrowKeys,
                role: 'progressbar'
              },
              _react2.default.createElement('div', {
                className: 'fullscreen-video-controls-volume-bar pro-fullscreen-fill',
                style: { width: (mute ? 0 : volume * 100) + '%' }
              })
            )
          )
        )
      );
      var videoOverlay = _utils.utils.isMobile() ? _react2.default.createElement('div', {
        className: 'fullscreen-mobile-external-video-overlay',
        style: { height: item.height * 0.7, width: item.width },
        onTouchEnd: function onTouchEnd() {
          return _this3.togglePlay();
        }
      }) : '';

      var configs = this.isExternalMobileVideo() ? {
        youtubeConfig: { playerVars: { playsinline: 0 } },
        vimeoConfig: { iframeParams: { playsinline: 0 } }
      } : '';
      var url = void 0;
      if (this.shouldUseWixUrl) {
        url = this.state.wixLocalUrl;
      } else {
        url = item.videoUrl ? item.videoUrl : item.resized_url.mp4;
      }
      var isMobileExternalVideoPlayed = item.metadata.isExternal && this.state.playedOnce && _utils.utils.isMobile();

      if (isDummy) {
        try {
          if (typeof this.props.actions.setItemLoaded === 'function') {
            this.props.actions.setItemLoaded();
          }
        } catch (e) {
          console.error(e);
        }
      }

      return !isDummy ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_fullscreenItemPreload2.default, {
          item: item,
          scale: this.props.window.scale.min(item),
          loaded: this.state.loaded
        }),
        _react2.default.createElement(
          'div',
          {
            'data-hook': 'fullscreen-video',
            className: 'fullscreen-content  fullscreen-item fullscreen-item-video fullscreen-item-' + item.idx + (_utils.utils.isiOS() ? ' pro-fullscreen-ios' : ''),
            style: (0, _extends3.default)({}, innerStyle, {
              display: 'flex', alignItems: 'center', justifyContent: 'center' }),
            key: 'video_container'
          },
          _react2.default.createElement(_reactPlayer2.default, (0, _extends3.default)({
            url: url,
            loop: !!this.props.styleParams.videoLoop,
            width: item.width,
            height: item.height,
            className: 'fullscreen-video fullscreen-video-' + item.idx,
            id: 'fullscreen-video-' + this.props.item.id,
            style: innerStyle,
            ref: function ref(video) {
              _this3.video = video;
            },
            playing: isDisplayed && playing,
            volume: mute ? 0 : volume,
            onReady: function onReady() {
              _this3.setState({ loaded: true });
              _this3.props.actions.setItemLoaded();
              _this3.fixIFrameTabIndexIfNeeded();
              console.log('fullscreen video onReady itemId: ' + item.idx);
            } //checking the only the correct video is loading
            , onStart: function onStart() {
              return console.log('fullscreen video onStart itemId: ' + item.idx);
            },
            onPlay: function onPlay() {
              return _this3.setState({ playing: true });
            },
            onPause: function onPause() {
              return _this3.setState({ playing: false });
            },
            onBuffer: function onBuffer(buffering) {
              return _this3.setState({ buffering: buffering });
            },
            onEnded: function onEnded() {
              return !!_this3.props.styleParams.videoLoop || _this3.setState({ playing: false });
            },
            onError: function onError(e) {
              return console.log('onError', e);
            },
            onProgress: function onProgress(_ref2) {
              var played = _ref2.played;
              return _this3.setState({ played: played });
            },
            onDuration: function onDuration(duration) {
              return _this3.setState({ duration: duration });
            },
            onWrapperClick: this.onWrapperClick.bind(this),
            playbackRate: this.props.styleParams.videoSpeed || 1,
            config: {
              file: {
                attributes: {
                  poster: item.resized_url.img
                }
              } },
            controls: item.metadata.isExternal || _utils.utils.isiOS()
          }, configs)),
          this.isExternalMobileVideo() || playing ? '' : _react2.default.createElement(
            'div',
            {
              onClick: function onClick() {
                _this3.togglePlay();
              }
            },
            _react2.default.createElement('i', {
              className: 'cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-triangle  ' + (item.metadata.isExternal ? ' pro-fullscreen-external' : '')
            }),
            _react2.default.createElement('i', {
              className: 'cursor-pointer fullscreen-item-video-play progallery-svg-font-icons-play-background ' + (item.metadata.isExternal ? ' pro-fullscreen-external' : '')
            })
          ),
          videoOverlay,
          item.metadata.isExternal ? '' : videoControls
        )
      ) :
      // slides on the left or right
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_fullscreenItemPreload2.default, {
          item: item,
          scale: this.props.window.scale.min(item),
          loaded: this.state.loaded
        }),
        _react2.default.createElement(
          'video',
          {
            preload: 'none',
            width: item.width,
            height: item.height,
            poster: item.resized_url.img,
            className: 'fullscreen-item fullscreen-video-' + this.props.item.idx,
            key: 'video',
            style: innerStyle,
            ref: function ref(video) {
              _this3.video = video;
            }
          },
          _react2.default.createElement('source', { src: item.resized_url.mp4, type: 'video/mp4' }),
          _react2.default.createElement('source', { src: item.resized_url.webm, type: 'video/webm' })
        )
      );
    }
  }]);
  return FullscreenVideo;
}(_react2.default.Component);

exports.default = FullscreenVideo;